export var defaultMonthOptions = {
    width: 7,
    height: 6,
    firstDayOfWeek: 1
};
export var defaultFormatOptions = {
    locale: 'en',
    monthTitle: 'MMMM',
    yearTitle: 'YYYY',
    dayLabel: 'D',
    weekNumbers: 'w'
};
export var defaultRenderOptions = {
    displayMonths: 1,
    showWeekNumbers: true
};
//# sourceMappingURL=_defaults.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/reducer/_defaults.js
// module id = 867
// module chunks = 103